import { CLASSIFICATION_CUBE_NAME } from '@/api/hcp';
import { GetOptionsQueryFunction } from '@/types/cube';
import { FilterConfigDynamic } from '@/types/filter';
import { toStringOrNull } from '@/utils/cube';

const HCP_PROFESSION_OPTIONS: GetOptionsQueryFunction = ({ sourceCube }) => ({
  dimensions: [`${sourceCube}.potential`],
  limit: undefined,
});

const potentialRatingFilter: FilterConfigDynamic = {
  label: 'global.filters.formControls.potentialRatingLabel',
  sourceCube: CLASSIFICATION_CUBE_NAME,
  defaultValue: [],
  getOptionsQuery: HCP_PROFESSION_OPTIONS,
  mapResult: result => {
    const value = toStringOrNull(result[`${CLASSIFICATION_CUBE_NAME}.potential`]);
    if (value === null) return null;
    return { value, label: value };
  },
  type: 'multiselect',
  clearable: true,
  placeholder: 'global.filters.formControls.potentialRatingLabelPlaceholder',
  searchable: true,
  applyFilter: potentialFilterValue => {
    let potentialValues: string[] = [];

    if (Array.isArray(potentialFilterValue)) {
      potentialValues = potentialFilterValue.filter((entry): entry is string => typeof entry === 'string');
    } else if (typeof potentialFilterValue === 'string') {
      potentialValues = [potentialFilterValue];
    }

    return {
      member: `${CLASSIFICATION_CUBE_NAME}.potential`,
      operator: 'equals',
      values: potentialValues,
    };
  },
};

export default potentialRatingFilter;
